export default {
    metaInfo() {
        return {
            title: `${this.meta.title} | CompareCards.com`,
            meta: [
                { vmid: 'robots', name: 'robots', content: `${this.meta.robots}` },
                { vmid: 'description', name: 'description', content: `${this.meta.description}` },
                { vmid: 'keywords', name: 'keywords', content: `${this.meta.keywords}` },
                { vmid: 'og:title', property: 'og:title', content: `${this.meta.og && this.meta.og.title} | CompareCards.com` },
                { vmid: 'og:description', property: 'og:description', content: `${this.meta.og && this.meta.og.description}` },
                { vmid: 'og:url', property: 'og:url', content: `${this.meta.og && this.meta.og.url}` },
                { vmid: 'og:image', property: 'og:image', content: `${this.meta.og && this.meta.og.imageUrl}` }
            ]
        }
    },
    computed: {
        meta: function () {
            return this.pageData && this.pageData.pageAttributes && this.pageData.pageAttributes.meta || {
                og: {}
            };
        },
    },
    beforeMount() {
        //updating canonical link url tag
        document.querySelector('link[rel="canonical"]').setAttribute('href', location.href);
    },
};